(ns frontend.view.settings2.authorized-applications.db
  (:require [reagent.core :as r]
            [frontend.db :as app-db]))

(def state (r/cursor app-db/app-state [:views :settings :authorized-applications]))
